import React from 'react';
import './RewardPopup.css'; // ✅ Import external CSS
import giftIcon from '../../images/shapes/gift-icon.png'; // ✅ Your icon path

const RewardPopup = ({ onClose }) => {
  return (
    <div className="reward-overlay">
      <div className="reward-popup">
        <h2 className="reward-title">Welcome!</h2>

        <img
          src={giftIcon}
          alt="Gift Icon"
          className="reward-icon"
        />

        <p className="reward-message">
          You received<br />
          <span className="reward-points">2000 TopCoin UK!</span>
        </p>

        <p className="reward-label">Reward</p>

        <button onClick={onClose} className="reward-button">
          OK
        </button>
      </div>
    </div>
  );
};

export default RewardPopup;
